orders-planner-lines
  .menus-wrap(if="{opts.dataEdit}")
    .menu-wrap(each="{id in opts.lines}" class="{ editable: opts.dataEdit }")
      orders-planner-line-ui-menu(tag-scope="{dataScopeLine(id)}" has-specific-phase="{hasSpecificPhase(id)}")
  .lines-wrap
    .scroll-container
      .line-wrap(each="{id in opts.lines}" class="{ editable: opts.dataEdit } {'phase-exist': hasSpecificPhase(id) }")
        orders-planner-line(tag-scope="{dataScopeLine(id)}")
        orders-planner-line-ui(if="{opts.dataEdit}" tag-scope="{dataScopeLine(id)}")
        orders-planner-line-ui-uneditable(if="{!opts.dataEdit}" tag-scope="{dataScopeLine(id)}")
  script(type="typescript").
    this.mixin('orders.planner.lines');
